/** 保留历史旅程值供支付归因识别，当前入口不再参与分流。 */
export const MEMBERSHIP_JOURNEY_VARIANTS = [
  'guided_paywall_v1',
  'direct_context_payment_v1'
] as const

export type MembershipJourneyVariant =
  (typeof MEMBERSHIP_JOURNEY_VARIANTS)[number]

/**
 * 所有团队统一先查看会员引导，再由用户主动进入购买页。
 *
 * 保留入口与埋点共用的解析函数，避免旧调用方继续按团队短 ID 分流。
 *
 * @param _teamShortID - 兼容已有调用签名，不再用于分流
 * @returns 全量启用的会员引导旅程
 * @example
 * ```ts
 * getMembershipJourneyVariant('420009') // 'guided_paywall_v1'
 * ```
 */
export const getMembershipJourneyVariant = (
  _teamShortID: string
): MembershipJourneyVariant => 'guided_paywall_v1'

/**
 * 为一次会员卡点生成支付全链路关联标识。
 *
 * @param occurredAt - 卡点发生时间，默认使用当前时间
 * @param entropy - 同毫秒内区分多次卡点的随机值
 * @returns 可写入神策通用字符串字段的短标识
 */
export const createMembershipPaywallAttemptID = (
  occurredAt = Date.now(),
  entropy = Math.random()
): string => {
  const normalizedEntropy = Math.max(0, Math.min(entropy, 0.999999999))
  const entropyToken = Math.floor(normalizedEntropy * 36 ** 6)
    .toString(36)
    .padStart(6, '0')
  return `bwm-${Math.max(0, Math.floor(occurredAt)).toString(36)}-${entropyToken}`
}
